<template lang="html">
  <div class="conversion-poster">
    <h1>- 知识合伙人等你来赚钱 -</h1>
    <img src="./images/poster.png" alt="" @click="$router.push('/money')">
  </div>
</template>

<script>
export default {
  name: 'ConversionPoster'
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.conversion-poster {
  text-align: center;
  h1 {
    color: #666666;
    font-size: rem(24);
    margin-bottom: rem(25);
  }
  > img {
    width: rem(680);
    box-shadow: rgba(#2E3748, .21) rem(0) rem(12) rem(14) rem(0);
    border-radius: rem(20);
  }
}
</style>
